import notification from "@/services/notification";
import DineInService from "@/services/store.dine-in";
import SecureLS from "secure-ls";
import router from "../router";

const ls = new SecureLS({
  encodingType: "rc4",
  isCompression: false,
  encryptionSecret: "Zs%Ma??5Qn,!ZB#_nhM"
});

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    viewTableInfo: ls.get("viewTableInfo") || null,
    tableGroup: [],
    tableList: [],
    pagination: {},
    tableData: null,
    lastTableUuid: 0,
  },
  mutations: {
    loading(state, value) {
      state.loading = value;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setPagination(state, value) {
      state.pagination = value;
    },
    setTableGroupList(state, data) {
      state.tableGroup = data;
    },
    setTableList(state, data) {
      state.tableList = data.map((item) => ({ ...item, table_number: item.table_id_number }));
    },
    setViewTableInfo(state, data) {
      state.viewTableInfo = data;
      ls.set("viewTableInfo", data);
    },
    removeViewTableInfo(state) {
      state.viewTableInfo = null;
      localStorage.removeItem("viewTableInfo");
    },
    setTableData(state, data) {
      state.tableData = data;
    },
    setLastTableUuid(state, data) {
      state.lastTableUuid = data;
    },
    emptyError(state, key) {
      state.errors[key] = "";
    }
  },
  actions: {
    async getGroupTable({ commit }, { payload = null, page }) {
      commit("loading", true);
      commit("setErrors", null);
      commit("setTableGroupList", []);
      try {
        const { data, prev_page, max_page } = await DineInService.getGroupTable({ payload, page });
        commit("setTableGroupList", data);
        commit("setPagination", {
          currentPage: page,
          previousPage: prev_page,
          maxPage: max_page,
        });
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    },
    async getTableList({ commit }, { payload = null, page, uuid }) {
      commit("loading", true);
      commit("setErrors", null);
      commit("setTableList", []);
      if(page == 1 && !payload.hasOwnProperty('keyword'))
        commit("setLastTableUuid", 0);
      try {
        const { data, prev_page, max_page } = await DineInService.getTableList({ payload, page, uuid });
        commit("setTableList", data);
        commit("setPagination", {
          currentPage: page,
          previousPage: prev_page,
          maxPage: max_page
        });

        if(page == 1 && data.length && !payload.hasOwnProperty('keyword')) commit("setLastTableUuid", data[0].uuid) // assuming tables are ordered by desc
        if(page == 1 && !data.length && !payload.hasOwnProperty('keyword')) router.push({ name: "DineInList" });
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    },
    async toggleTableVisibility({ commit }, payload) {
      commit("loading", true);
      commit("setErrors", null);
      try {
        await DineInService.toggleTableVisibility(payload);
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    },
    async createGroupTable({ commit }, payload) {
      commit("loading", true);
      commit("setErrors", null);
      try {
        const { message } = await DineInService.createGroupTable(payload);
        notification.success(message);
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    },
    async viewGroupTable({ commit }, uuid) {
      commit("loading", true);
      commit("setErrors", null);
      try {
        const { data } = await DineInService.viewGroupTable(uuid);
        commit("setTableData", data);
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    },
    async updateGroupTable({ commit }, payload) {
      commit("loading", true);
      commit("setErrors", null);
      try {
        const { message } = await DineInService.updateGroupTable(payload);
        notification.success(message);
      } catch ({ errors }) {
        commit("setErrors", errors);
      } finally {
        commit("loading", false);
      }
    },
    async deleteGroupTable({ commit }, payload) {
      commit("loading", true);
      commit("setErrors", null);
      try {
        const { message } = await DineInService.deleteGroupTable(payload);
        notification.success(message);
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    },
    async deleteTable({ commit }, payload) {
      commit("loading", true);
      commit("setErrors", null);
      try {
        const { message } = await DineInService.deleteTable(payload);
        notification.success(message);
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("loading", false);
      }
    }
  }
}
